import * as React from "react"
export const Svg_030 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={59}
    fill="none"
  >
    <path fill="url(#a)" d="M19.556 30.756H42v4.468H19.556v-4.468Z" />
    <path fill="url(#b)" d="M16 22.83h22.444V27.3H16V22.83Z" />
    <path fill="url(#c)" d="M16 54.532h22.444V59H16v-4.468Z" />
    <path fill="url(#d)" d="M16 38.681h22.444v4.468H16v-4.468Z" />
    <path fill="url(#e)" d="M19.556 46.606H42v4.469H19.556v-4.469Z" />
    <path
      fill="url(#f)"
      d="M36.744 9.687C36.744 4.345 32.473 0 27.222 0 21.972 0 17.7 4.345 17.7 9.687c0 5.34 4.271 9.686 9.522 9.686 5.25 0 9.522-4.345 9.522-9.686Zm-7.823 1.728h-3.398V7.958h3.398v3.457Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={24.746}
        x2={25.322}
        y1={31.426}
        y2={36.101}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={21.19}
        x2={21.765}
        y1={23.501}
        y2={28.176}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={21.19}
        x2={21.765}
        y1={55.202}
        y2={59.878}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={21.19}
        x2={21.765}
        y1={39.351}
        y2={44.027}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={24.746}
        x2={25.322}
        y1={47.277}
        y2={51.952}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={22.104}
        x2={31.375}
        y1={2.906}
        y2={17.657}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)